/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type DecentralizationSubScore = {
  /**
   * Countries Score
   */
  countries?: string | undefined;
  /**
   * Cities Score
   */
  cities?: string | undefined;
  /**
   * Data Centers Score
   */
  dataCenters?: string | undefined;
  /**
   * Node Providers Score
   */
  nodeProviders?: string | undefined;
  /**
   * Data Center Owners Score
   */
  dataCenterOwners?: string | undefined;
};

/** @internal */
export const DecentralizationSubScore$inboundSchema: z.ZodType<
  DecentralizationSubScore,
  z.ZodTypeDef,
  unknown
> = z.object({
  countries: z.string().optional(),
  cities: z.string().optional(),
  data_centers: z.string().optional(),
  node_providers: z.string().optional(),
  data_center_owners: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "data_centers": "dataCenters",
    "node_providers": "nodeProviders",
    "data_center_owners": "dataCenterOwners",
  });
});

/** @internal */
export type DecentralizationSubScore$Outbound = {
  countries?: string | undefined;
  cities?: string | undefined;
  data_centers?: string | undefined;
  node_providers?: string | undefined;
  data_center_owners?: string | undefined;
};

/** @internal */
export const DecentralizationSubScore$outboundSchema: z.ZodType<
  DecentralizationSubScore$Outbound,
  z.ZodTypeDef,
  DecentralizationSubScore
> = z.object({
  countries: z.string().optional(),
  cities: z.string().optional(),
  dataCenters: z.string().optional(),
  nodeProviders: z.string().optional(),
  dataCenterOwners: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    dataCenters: "data_centers",
    nodeProviders: "node_providers",
    dataCenterOwners: "data_center_owners",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DecentralizationSubScore$ {
  /** @deprecated use `DecentralizationSubScore$inboundSchema` instead. */
  export const inboundSchema = DecentralizationSubScore$inboundSchema;
  /** @deprecated use `DecentralizationSubScore$outboundSchema` instead. */
  export const outboundSchema = DecentralizationSubScore$outboundSchema;
  /** @deprecated use `DecentralizationSubScore$Outbound` instead. */
  export type Outbound = DecentralizationSubScore$Outbound;
}

export function decentralizationSubScoreToJSON(
  decentralizationSubScore: DecentralizationSubScore,
): string {
  return JSON.stringify(
    DecentralizationSubScore$outboundSchema.parse(decentralizationSubScore),
  );
}

export function decentralizationSubScoreFromJSON(
  jsonString: string,
): SafeParseResult<DecentralizationSubScore, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DecentralizationSubScore$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DecentralizationSubScore' from JSON`,
  );
}
